import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import { useNavigate } from "react-router-dom";
import "./ExportDownload.scss";
import Backbutton2 from "../../images/Backbutton2.svg";
import { toast } from "react-toastify";
import { postBinder } from "../../services/apis";
import CircularProgressBar from "../../utils/CircularProgressBar";
import CloseIcon from "../../images/Close-Small.svg";
import SuccessIcon from "../../images/Success-Icon.svg";
import ErrorIcon from "../../images/Error-Icon.svg";
import { showChildrenPropsToast, showErrorToast, showSuccessToast } from "../toastComponent/ToastComponent";

const ExportHeader = ({
  setOpenMLRPDF,
  setExportFormats,
  pdfURL,
  deckData,
  setMLR,
  setClickOnSubmit,
  clickOnSubmit,
  handleApprovedtemplateModal,
  submitMLR,
  loading,
  setLoading,
  mlrData,
  setPreviewLoading,
  previewData
}) => {
  const navigate = useNavigate();
  const [mlrStatus, setMlrStatus] = useState(mlrData?.statusMLR);

  const successToast = (data) => {
    // toast.success(
    //   <div className="mlrSubmissionStatusMsg">
    //     <p className="mlr-submission-header">Binder Submission Successful</p>

    //     <span className="mlr-submission row">
    //       <span className="mlr-submission-title col-md-5">Binder ID :</span>

    //       <span className="mlr-submission-content col-md-7">
    //         {data.pdfNo} {data.htmlNo}
    //       </span>
    //     </span>

    //     <span className="mlr-submission row">
    //       <span className="mlr-submission-title col-md-5">Submitted by:</span>

    //       <span className="mlr-submission-content col-md-7">
    //         {data.created.name}
    //       </span>
    //     </span>

    //     <span className="mlr-submission row">
    //       <span className="mlr-submission-title col-md-5">Time Stamp:</span>

    //       <span className="mlr-submission-content col-md-7">
    //         {new Date(data.updated_at).toString()}
    //       </span>
    //     </span>
    //   </div>,

    //   {
    //     position: "top-right",

    //     autoClose: 5000,

    //     icon: <img className="toast-mlr-success-icon" src={SuccessIcon} />,

    //     hideProgressBar: true,

    //     closeOnClick: true,

    //     pauseOnHover: true,

    //     draggable: false,

    //     closeButton: (
    //       <img className="toast-mlr-success-close-icon" src={CloseIcon} />
    //     ),

    //     className: "toast-popup toast-success-popup",
    //   }
    // );
  };

  function downlaodPDF(pdfURL) {
    var url = pdfURL + ".zip";
    window.open(url, "_blank");
    showSuccessToast('Download Successful');
  }
  
  const submitBinder = () => {
    setLoading(true);
    postBinder(
      deckData?.id,
      { zipUrl: pdfURL + ".zip" },
      (response, err, errorCode) => {
        if (err) {
          setLoading(false);
          showErrorToast(err?.response?.data?.err||"Binder Submission Failed_Please try again");
        } else {
          setLoading(false);
          showChildrenPropsToast(<div className="mlrSubmissionStatusMsg">
            <p className="mlr-submission-header">
              Binder Submission Successful
            </p>

            <span className="mlr-submission row">
              <span className="mlr-submission-title col-md-7">
                MLR ID : {mlrData?.docNumber}
              </span>
            </span>
          </div>);
        }
      }
    );
  };
  const goToDashboard = () => {
    navigate("/edetail-manager");
  };
// console.log(previewData,"previewData")
  return (
    <>
      <CircularProgressBar isloading={loading} />
      <div className="header">
        <div className="header-left-part">
          <img
            src={Backbutton2}
            alt=""
            className="backarowPreview"
            onClick={goToDashboard}
          />
          <h5>
            <span className="header-left-part_pdf">HTML</span> PACKAGE
          </h5>
        </div>
        <div className="header-right-part">
          <Button
            className="button download-pdf"
            onClick={(e) => downlaodPDF(pdfURL)}
          >
            DOWNLOAD PACKAGE
          </Button>
          { previewData?.type === 2 &&<Button
              className="button submit-mlr"
            // className={`button submit-mlr ${
            //   mlrData?.docStatus?.toUpperCase() === "APPROVED"
            //     ? "disabled-subMlr-btn"
            //     : ""
            // }`}
            title={
              mlrData?.docStatus?.toUpperCase() !== "APPROVED"
                ? "Only Approved e-Detail PDF can be submitted"
                : ""
            }
           // disabled={mlrData?.docStatus?.toUpperCase() === "APPROVED"}
            onClick={() => submitBinder()}
          >
            SUBMIT TO BINDER
          </Button> }
        </div>
      </div>
    </>
  );
};

export default ExportHeader;
